<template>
	<div id="app" :class="themeColorScheme">
		<div v-if="general.status == 0 && responce.code == 200000">
			<Closed />
		</div>
		<div v-else-if="responce.code == 500000">
			<Error500 />
		</div>
		<div v-else>
			<TheGlobal />
			<div class="iv2-side position-fixed">
				<TheExtra />
				<TheExtraSNS />
			</div>
			<transition mode="out-in" :name="pageAnimation">
				<router-view :animation="pageAnimation" />
			</transition>

			<TheFooter />

			<!-- タブレット、スマホのみ表示 -->
			<TheBottom />

			<!-- item -->
			<BasePagetop />
		</div>
	</div>
</template>

<script>
import Error500 from "./components/system/Error500.vue";
import Closed from "./components/system/Closed.vue";

import TheGlobal from "./components/global/TheGlobal.vue";
import TheExtra from "./components/global/TheExtra.vue";
import TheExtraSNS from "./components/global/TheExtraSNS.vue";
import TheFooter from "./components/global/TheFooter.vue";
import TheBottom from "./components/global/TheBottom.vue";

// item
import BasePagetop from "./components/item/BasePagetop.vue";

export default {
	components: {
		Error500,
		Closed,
		TheGlobal,
		TheExtra,
		TheExtraSNS,
		TheFooter,
		TheBottom,

		BasePagetop,
	},

	data() {
		return {
			responce: {
				version: "1.0.0",
				code: 200000,
				message: "OK",
				detail:
					"正常なリクエストおよびレスポンスとして実行されました。",
			},

			general: [],

			pageAnimation: "fade",
			themeColorScheme: "theme-b__wood",

			userAgent: "",
		};
	},

	created() {
		this.axios.get("/json/settings.json").then((response) => {
			this.general = response.data.settings.general;
		});

		this.userAgent = navigator.userAgent;

		setInterval(() => {
			if (
				this.userAgent.indexOf("Safari") != -1 &&
				this.userAgent.indexOf("Chrome") == -1
			) {
				navigator.serviceWorker.controller.postMessage("updateCache");
				window.location.reload(true);
			}
		}, 60 * 60 * 1000);
	},

	mounted() {
		this.$ga.page(this.$route.path);
	},

	watch: {
		$route: function (to, from) {
			if (to.path !== from.path) {
				this.$ga.page(this.$route.path);
			}
		},
	},
};
</script>

<style lang="scss"></style>
